const PencilIcon = (props) => {
    return <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="22"
    viewBox="0 0 22 22"
    {...props}
  >
    <g clip-path="url(#clip0_374_1149)">
      <path
        d="M13.5861 3.69455L1.48148 15.8001C1.42053 15.8612 1.37708 15.9376 1.35569 16.0212L0.0139577 21.4065C-0.00577574 21.4864 -0.00456641 21.5701 0.0174689 21.6494C0.0395042 21.7287 0.0816207 21.801 0.13975 21.8593C0.229037 21.9483 0.349927 21.9983 0.475987 21.9984C0.514874 21.9984 0.553613 21.9936 0.591326 21.9841L5.9766 20.6422C6.06034 20.6211 6.13677 20.5777 6.19772 20.5166L18.3035 8.41182L13.5861 3.69455ZM21.3023 2.04397L19.9549 0.69657C19.0543 -0.203991 17.4847 -0.203097 16.5852 0.69657L14.9346 2.34715L19.6518 7.06424L21.3023 5.41371C21.7521 4.96405 21.9999 4.36551 21.9999 3.72895C21.9999 3.09239 21.7521 2.49385 21.3023 2.04397Z"
        fill="currentcolor"
      />
    </g>
    <defs>
      <clipPath id="clip0_374_1149">
        <rect width="22" height="22" fill="currentcolor" />
      </clipPath>
    </defs>
  </svg>
}

export default PencilIcon;